import { RootState } from "@/modules/common";

export const selectSaturdayDelivery = (state: RootState) =>
  state.basket.basket.products.find(product => product.saturdayDelivery);
